import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BindAndIssueComponent } from './bind-and-issue/bind-and-issue.component';
import { BindAndIssueBasicInfoComponent } from './bind-and-issue-basic-info/bind-and-issue-basic-info.component';
import { BindAndIssueReviewComponent } from './bind-and-issue-review/bind-and-issue-review.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderModule } from 'src/app/header/header.module';
import { HomeModule } from 'src/app/home/home.module';
import { BindConfirmationComponent } from './bind-confirmation/bind-confirmation.component';



@NgModule({
  declarations: [BindAndIssueComponent, BindAndIssueBasicInfoComponent, BindAndIssueReviewComponent, BindConfirmationComponent],
  imports: [
    CommonModule,
    NgbModule,
    HeaderModule,
    HomeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class BindAndIssueModule { }
